export default "__VITE_ASSET__D75N7QFG__";